export default __webpack_public_path__ + "5ee5d2dab921ea0cdb1638c0241c48a7.svg";